import React, {Component} from "react"
import {
    Container,
    Col,
    Row,
    Toast, ToastBody, ToastHeader, TabContent, TabPane, Nav, NavItem, NavLink} from 'reactstrap'
    import classnames from 'classnames';
    import Slides from "./Slides";
    import FAQ from "./data/FAQ.js"
    import Topics from "./data/Topics.js"
    import { Waypoint } from 'react-waypoint';
    import JoinUN from "./JoinUN"
    import General from "./data/General"
    import {isMobile} from 'react-device-detect';

    class Intro extends Component {
        constructor(props) {
          super(props);
          this.state = {
              count:0,
              uncount:0,
              activeTab: '1',
              activeColor:false,
              mobile:isMobile
          }
          this.handleFlourish = this.handleFlourish.bind(this);
          this.handleUN = this.handleUN.bind(this);
          this.toggle = this.toggle.bind(this);
        }

        handleFlourish() {
            this.setState(prevState => {
                return {
                    count: 1
                }
            })
        }
        handleUN() {
            this.setState(prevState => {
                return {
                    uncount: 1
                }
            })
        }
        toggle(tab) {
            if (this.state.activeTab !== tab) {
              this.setState({
                activeTab: tab,
                activeColor:true
              });
            }
          }

        render() {
            let flourishembed= this.state.count===1?  <iframe src='./flourish/flourish.html' frameborder='0' scrolling='no' style={{width:"100%",height:"450px"}}></iframe> : <p>&nbsp;</p>
            let worldflags=  this.state.uncount===1? <div className="row boxes row-eq-height"> 
            <div className="countrybox col-12">
            <div className="joinbox founders">
             <JoinUN year1={1945} year2={2020}/>        
            </div>
            </div>
        </div> : <p>&nbsp;</p>
        let comment = this.state.mobile ? "تنقل بين أعلام الدول لمعرفة التفاصيل":"تنقل بين أعلام الدول لمعرفة التفاصيل"
    return(
      <div>
            <Container>
                <Row className="justify-content-center opening">
                    <Col lg="10" md="10" xs="12" className="text-right">
                    <h2 className="display-2 text-center">{General[0].chapterAR}</h2>
                        <p className="text-right">{General[0].subAR}</p>
                        <h3 className="strong">متى انضمت دول العالم إلى الأمم المتحدة</h3>
                        <em className="gray pad--20">{comment}</em>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col lg="10" md="10" xs="12" >
                    <Waypoint onEnter={()=> {this.handleUN()}}/>
                    {worldflags}
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col lg="10" md="10" xs="12" className="text-right">
                        <br/>
                        <p className="text-right">{General[4].subAR}</p>
                    </Col>
                </Row>
            </Container>

          <Container fluid className="toknow">
                <Slides caption={General[8].chapterAR} dataset={FAQ}/>
        </Container>

            
            <Container>
            <Row className="justify-content-center">
            <Col lg="10" md="10" xs="12">
            <h2 class="display-2 text-center">{General[1].chapterAR}</h2>
                <p className="text-right">{General[1].subAR}</p>
            </Col>
            </Row>

            <br/>
            <Row className="justify-content-center">
            <Col lg="10" md="10" xs="12" className="text-right">

            <Waypoint onEnter={()=> {this.handleFlourish()}}/>  
            {flourishembed}
            </Col>
            </Row>
            <Row className="justify-content-center">
            <Col lg="10" md="10" xs="12">
        <Nav tabs>
          <NavItem >
            <NavLink
              className={classnames({ active: this.state.activeTab === '1' , "israel":true} )}
              onClick={() => { this.toggle('1'); }}
            ><h3 className="toast-color">&nbsp;&nbsp;</h3>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '2' , "nuclear":true})}
              onClick={() => { this.toggle('2'); }}
            ><h3 className="toast-color">&nbsp;&nbsp;</h3>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '3', "arms":true})}
              onClick={() => { this.toggle('3'); }}
            ><h3 className="toast-color">&nbsp;&nbsp;</h3>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '4', "humanrights":true})}
              onClick={() => { this.toggle('4'); }}
            ><h3 className="toast-color">&nbsp;&nbsp;</h3>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '5',  "colonialism":true} )}
              onClick={() => { this.toggle('5'); }}
            ><h3 className="toast-color">&nbsp;&nbsp;</h3>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '6',  "economic":true} )}
              onClick={() => { this.toggle('6'); }}
            ><h3 className="toast-color">&nbsp;&nbsp;</h3>
            </NavLink>
          </NavItem>


        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <Row>
                <Col xs="12">
                <div className="p-3 my-2 israel">
                <Toast>
                    <ToastHeader>
                    <h3 className="text-right">{Topics[0].topicAR}</h3>
                    </ToastHeader>
                    <ToastBody>
                        <p className="text-right">{Topics[0].descriptionAR}</p>
                        <em className="text-right gray">{General[17].chapterAR}</em>
                        <p className="text-right subtopics israelco">{Topics[0].subtopicAR}</p>
                    </ToastBody>
                </Toast>
                </div>
                </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
                <Col xs="12" className="text-right">
                    <div className="p-3 my-2 nuclear">
                    <Toast>
                        <ToastHeader>
                        <h3 className="text-right">{Topics[1].topicAR}</h3>
                        </ToastHeader>
                        <ToastBody>
                            <p className="text-right">{Topics[1].descriptionAR}</p>
                            <em className="text-right gray">{General[17].chapterAR}</em>
                            <p className="text-right subtopics nuclearco">{Topics[1].subtopicAR}</p>
                        </ToastBody>
                    </Toast>
                    </div>
                </Col>
            </Row>
          </TabPane>

          <TabPane tabId="3">
            <Row>
                <Col xs="12">
                <div className="p-3 my-2 arms">
                <Toast>
                    <ToastHeader>
                    <h3 className="text-right">{Topics[2].topicAR}</h3>
                    </ToastHeader>
                    <ToastBody>
                        <p className="text-right">{Topics[2].descriptionAR}</p>
                        <em className="text-right gray">{General[17].chapterAR}</em>
                        <p className="text-right subtopics armsco">{Topics[2].subtopicAR}</p>
                    </ToastBody>
                </Toast>
                </div>
                </Col>
            </Row>
          </TabPane>
          <TabPane tabId="4">
            <Row>
                <Col xs="12" className="text-right">
                <div className="p-3 my-2 humanrights">
                <Toast>
                    <ToastHeader>
                    <h3 className="text-right">{Topics[4].topicAR}</h3>
                    </ToastHeader>
                    <ToastBody>
                        <p className="text-right">{Topics[4].descriptionAR}.</p>
                        <em className="text-right gray">{General[17].chapterAR}</em>
                        <p className="text-right subtopics humanrightsco">{Topics[4].subtopicAR}</p>
                    </ToastBody>
                </Toast>
                </div>
                </Col>
            </Row>
          </TabPane>

          <TabPane tabId="5">
            <Row>
                <Col xs="12">
                <div className="p-3 my-2 colonialism">
                <Toast>
                    <ToastHeader>
                    <h3 className="text-right">{Topics[3].topicAR}</h3>
                    </ToastHeader>
                    <ToastBody>
                        <p className="text-right">{Topics[3].descriptionAR}</p>
                        <em className="text-right gray">{General[17].chapterAR}</em>
                        <p className="text-right subtopics colonialismco">{Topics[3].subtopicAR}</p>
                    </ToastBody>
                </Toast>
                </div>
                </Col>
            </Row>
          </TabPane>
          <TabPane tabId="6">
            <Row>
                <Col xs="12" className="text-right">
                    <div className="p-3 my-2 economic">
                    <Toast>
                        <ToastHeader>
                        <h3 className="text-right">{Topics[5].topicAR}</h3>
                        </ToastHeader>
                        <ToastBody>
                            <p className="text-right">{Topics[5].descriptionAR}</p>
                            <em className="text-right gray">{General[17].chapterAR}</em>
                            <p className="text-right subtopics economicco">{Topics[5].subtopicAR}</p>
                        </ToastBody>
                    </Toast>
                    </div>
                </Col>
            </Row>
          </TabPane>
        </TabContent>
        </Col>
        </Row>
        <br/>
        <hr/>
        </Container>
    </div>
    )

}
}
export default Intro